import React, { useState } from "react";
import ComplianceFolder from "./components/ComplianceFolder";
import ComplianceSearchBar from "./components/ComplianceSearchBar";
import { screenStyles as styles } from "./components/complianceStyles";
import { COMPLIANCE_FOLDERS } from "./model/complianceFolders";

// Suivi conformité : un bloc par autorité de contrôle, avec ses documents attendus, ses fichiers et une recherche commune.
export default function SuiviConformite() {
    const [searchTerm, setSearchTerm] = useState("");

    return (
        <main style={styles.page}>
            <div style={styles.layout}>
                <header>
                    <p style={styles.eyebrow}>
                        Suivi conformité
                    </p>
                    <h1 style={styles.title}>Suivi conformité</h1>
                </header>
                <ComplianceSearchBar searchTerm={searchTerm} onChange={setSearchTerm} />
                {COMPLIANCE_FOLDERS.map(folder => (
                    <ComplianceFolder key={folder.key} folder={folder} searchTerm={searchTerm} />
                ))}
            </div>
        </main>
    );
}
